import { useCallback } from 'react';
import { useMutateEntry } from '@utils/component-framework';

const useUpdateIGuideEntryLocationMutation = entryKey => {
  const updateComponentEntry = useMutateEntry(entryKey);
  return useCallback(taskId => {
    updateComponentEntry(entry => {
      entry.data.currentTaskId = taskId;
      return entry;
    });
  }, [updateComponentEntry]);
};

export { useUpdateIGuideEntryLocationMutation };
//# sourceMappingURL=mutation.update-entry-location.js.map
